import React, { useEffect, useState } from "react";
import AadharVerify from "./aadharVerify";
import { updateLoan } from "../../../apis/loans";

const AgreementModal = ({ setIsApproved, agreementData }) => {
    const [agreementAccepted, setIsAgreementAccepted] = useState<boolean>(false);
    const [customerVerified, setCustomerVerified] = useState(Boolean(agreementData?.is_verified));
    const [guarantorVerified, setGuarantorVerified] = useState(Boolean(agreementData?.is_guarantor_verified));
    const [isAccepted, setIsAccepted] = useState(Boolean(agreementData?.is_terms_verified));
    const [showSuccess, setShowSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState("");

    useEffect(() => {
        setCustomerVerified(Boolean(agreementData?.is_verified));
        setGuarantorVerified(Boolean(agreementData?.is_guarantor_verified));
        setIsAccepted(Boolean(agreementData?.is_terms_verified));
        setIsApproved(Boolean(
            agreementData?.is_verified &&
            agreementData?.is_guarantor_verified &&
            agreementData?.is_terms_verified
        ));
        setIsAgreementAccepted(false);
        setSubmitError("");
    }, [
        agreementData?.id,
        agreementData?.is_verified,
        agreementData?.is_guarantor_verified,
        agreementData?.is_terms_verified,
        setIsApproved,
    ]);

    const checkAgreementConditions = async () => {
        if (!isAccepted || !customerVerified || !guarantorVerified) {
            setIsAgreementAccepted(true);
            setIsApproved(false);
            return;
        }

        setIsAgreementAccepted(false);
        setSubmitError("");
        setIsSubmitting(true);

        try {
            await updateLoan(agreementData?.id, { is_terms_verified: true });
            setIsApproved(true);
            setShowSuccess(true);
        } catch (error) {
            setIsApproved(false);
            setSubmitError("Unable to complete the agreement. Please try again.");
            console.error("Error updating agreement verification", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const changeModal = () => {
        const modalEl = document.getElementById("otp_verification_modal");

        if (!modalEl) return;

        const modalInstance = window.bootstrap.Modal.getInstance(modalEl)
            || new window.bootstrap.Modal(modalEl);

        modalInstance.hide();
    };

    return (
        <>
            <style>{`
                @media (max-width: 767px) {
                    #otp_verification_modal {
                        z-index: 1200;
                    }
                    .am-cards-row {
                        flex-direction: column !important;
                    }
                    .am-modal-dialog {
                        margin: 8px !important;
                        max-width: calc(100% - 16px) !important;
                    }
                    .am-header {
                        padding: 12px 14px !important;
                    }
                    .am-body {
                        padding: 14px !important;
                    }
                    .am-footer {
                        padding: 12px 14px 16px !important;
                    }
                    .am-modal-dialog .modal-content {
                        height: calc(100dvh - 16px) !important;
                        max-height: calc(100dvh - 16px) !important;
                    }
                    .am-body {
                        min-height: 0 !important;
                        overflow-y: auto !important;
                        overscroll-behavior: contain;
                        -webkit-overflow-scrolling: touch;
                    }
                    .am-header-title {
                        font-size: 14px !important;
                    }
                    .am-header-sub {
                        font-size: 11px !important;
                    }
                    .am-download-btn {
                        font-size: 14px !important;
                        padding: 11px 16px !important;
                    }
                }

                @media (min-width: 768px) and (max-width: 1023px) {
                    .am-cards-row {
                        flex-direction: column !important;
                    }
                    .am-modal-dialog {
                        margin: 16px auto !important;
                        max-width: calc(100% - 32px) !important;
                    }
                    .am-body {
                        padding: 18px !important;
                    }
                }
            `}</style>

            <div className="modal fade" id="otp_verification_modal">
                <div className="modal-dialog modal-dialog-centered modal-lg am-modal-dialog">
                    <div className="modal-content" style={styles.modalContent}>

                        <div className="am-header" style={styles.amHeader}>
                            <div style={styles.amHeaderInfo}>
                                <div style={styles.amHeaderIcon}>
                                    <i className="ti ti-file-certificate" />
                                </div>
                                <div>
                                    <p className="am-header-title" style={styles.amHeaderTitle}>Agreement Verification</p>
                                    <p className="am-header-sub" style={styles.amHeaderSub}>Secure document signing &amp; download</p>
                                </div>
                            </div>
                            {/* <div
                                style={styles.amClose}
                                // onClick={() => changeModal()}
                            > */}
                            <div
                                style={styles.amClose}
                                data-bs-dismiss="modal"
                            >
                                <i className="ti ti-x" />
                            </div>
                        </div>

                        <div className="am-body" style={styles.amBody}>
                            <div className="am-cards-row" style={styles.amCardsRow}>

                                {/* <div style={styles.amCard}>
                                    <div style={styles.amCardLabel}>
                                        <span style={styles.amCardLabelDot} />
                                        Digital Signature
                                    </div>
                           <DigitalSignature signatureURL={signatureURL} setSignatureURL={setSignatureURL} /> 
                                </div> */}

                                <div style={styles.amCard}>
                                    <div style={styles.amCardLabel}>
                                        <span style={styles.amCardLabelDot} />
                                        Customer Verification
                                    </div>
                                    <AadharVerify
                                        type="customer"
                                        loanId={agreementData?.id}
                                        isAlreadyVerified={customerVerified}
                                        defaultAadhar={agreementData?.aadharNumber}
                                        onVerified={(status) => setCustomerVerified(status)}
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="am-cards-row" style={styles.amCardsRow}>
                                <div style={styles.amCard}>
                                    <div style={styles.amCardLabel}>
                                        <span style={styles.amCardLabelDot} />
                                        Gurantor Verification
                                    </div>
                                    <AadharVerify
                                        type="guarantor"
                                        loanId={agreementData?.id}
                                        isAlreadyVerified={guarantorVerified}
                                        defaultAadhar={agreementData?.guarantor_aadhar_number}
                                        onVerified={(status) => setGuarantorVerified(status)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="am-footer" style={styles.amFooter}>
                            <div style={styles.amTermsRow}>
                                <input
                                    type="checkbox"
                                    id="acceptTerms"
                                    checked={isAccepted}
                                    onChange={(e) => {
                                        setIsAccepted(e.target.checked);
                                        setIsAgreementAccepted(false);
                                        setSubmitError("");
                                    }}
                                    style={styles.amCheckbox}
                                />
                                <label htmlFor="acceptTerms" style={styles.amTermsLabel}>
                                    {"I have read and accept the terms and conditions."}
                                </label>
                            </div>

                            <button
                                type="button"
                                className="am-download-btn"
                                style={{
                                    ...styles.amDownloadBtn,
                                    ...(isSubmitting ? styles.amDownloadBtnDisabled : {}),
                                }}
                                onClick={checkAgreementConditions}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Submitting..." : "Verify OTP & Download"}
                            </button>
                            {agreementAccepted && (
                                <span style={styles.errorText}>
                                    Please verify both Aadhaar numbers and accept the terms and conditions to proceed.
                                </span>
                            )}
                            {submitError && <span style={styles.errorText}>{submitError}</span>}
                        </div>

                    </div>
                </div>
            </div>

            {/* //success popup */}
            {showSuccess && (
                <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content" style={{ borderRadius: "12px", padding: "20px" }}>

                            <div style={{ textAlign: "center" }}>
                                <div style={{
                                    width: "60px",
                                    height: "60px",
                                    margin: "0 auto 12px",
                                    borderRadius: "50%",
                                    background: "#16a34a",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    fontSize: "28px"
                                }}>
                                    ✓
                                </div>

                                <h5 style={{ marginBottom: "8px" }}>Success</h5>
                                <p style={{ color: "#64748b" }}>
                                    Agreement verified successfully!
                                </p>

                                <button
                                    className="btn btn-success"
                                    onClick={() => {
                                        setShowSuccess(false);
                                        window.location.reload();
                                    }}
                                >
                                    OK
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
};



const styles: Record<string, React.CSSProperties> = {
    modalContent: {
        borderRadius: "16px",
        border: "none",
        overflow: "hidden",
        boxShadow: "0 25px 60px rgba(0,0,0,0.18)",
        display: "flex",
        flexDirection: "column",
        maxHeight: "90vh",
    },

    amHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 22px",
        background: "linear-gradient(135deg, #f0fdf4, #f8fafc)",
        borderBottom: "1px solid #e2e8f0",
        flexShrink: 0,
    },

    amHeaderInfo: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
    },

    amHeaderIcon: {
        width: "40px",
        height: "40px",
        borderRadius: "10px",
        background: "linear-gradient(135deg, #16a34a, #15803d)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: "18px",
        flexShrink: 0,
    },

    amHeaderTitle: {
        fontSize: "16px",
        fontWeight: 700,
        color: "#0f172a",
        margin: 0,
        lineHeight: 1.2,
    },

    amHeaderSub: {
        fontSize: "12px",
        color: "#64748b",
        margin: "2px 0 0",
    },

    amClose: {
        width: "32px",
        height: "32px",
        borderRadius: "8px",
        border: "1px solid #e2e8f0",
        background: "#fff",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#64748b",
        fontSize: "16px",
        flexShrink: 0,
    },

    amBody: {
        padding: "20px 22px",
        overflowY: "auto",
        minHeight: 0,
        WebkitOverflowScrolling: "touch",
        flex: 1,
        background: "#fff",
    },

    amCardsRow: {
        display: "flex",
        flexDirection: "row",
        gap: "16px",
        alignItems: "stretch",
    },

    amCard: {
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
        borderRadius: "12px",
        padding: "16px 18px",
        flex: "1 1 0",
        minWidth: 0,
    },

    amCardLabel: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "11px",
        fontWeight: 700,
        color: "#15803d",
        textTransform: "uppercase",
        letterSpacing: "0.7px",
        background: "#dcfce7",
        border: "1px solid #bbf7d0",
        padding: "3px 10px",
        borderRadius: "20px",
        marginBottom: "14px",
    },

    amCardLabelDot: {
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        background: "#16a34a",
    },

    amFooter: {
        padding: "14px 22px 18px",
        background: "#f8fafc",
        borderTop: "1px solid #e2e8f0",
        flexShrink: 0,
    },

    amTermsRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        marginBottom: "14px",
    },

    amCheckbox: {
        width: "17px",
        height: "17px",
        marginTop: "2px",
        accentColor: "#16a34a",
        cursor: "pointer",
        flexShrink: 0,
    },

    amTermsLabel: {
        fontSize: "13.5px",
        color: "#374151",
        lineHeight: 1.55,
        cursor: "pointer",
        margin: 0,
    },

    amDownloadBtn: {
        width: "100%",
        padding: "13px 20px",
        borderRadius: "10px",
        border: "none",
        background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
        color: "#fff",
        fontSize: "15px",
        fontWeight: 600,
        cursor: "pointer",
        letterSpacing: "0.2px",
        boxShadow: "0 4px 14px rgba(22,163,74,0.3)",
        display: "block",
    },

    amDownloadBtnDisabled: {
        opacity: 0.65,
        cursor: "not-allowed",
    },

    errorText: {
        display: "block",
        color: "#dc2626",
        fontSize: "13px",
        marginTop: "8px",
    }
};

export default AgreementModal;
